import { ReactElement, memo } from "react";

import Condition from "../../../Conditional/Condition";
import "./QuantitySelector.scss";
import "./QuantitySelector_flint.scss";
import "./QuantitySelector_kokoro.scss";
import "./QuantitySelector_pdd.scss";
import "./QuantitySelector_shabuDays.scss";
import "./QuantitySelector_torikizoku.scss";
import "./QuantitySelector_wang.scss";
import { useQuantitySelector } from "./useQuantitySelector";

interface IProps {
	max: number;
	onChange: (value: number) => void;
	initValue?: number;
	showZero?: boolean;
	testid?: string;
	inventoryCount?: number;
}

const QuantitySelector = ({
	max,
	onChange,
	initValue = 0,
	showZero = false,
	testid = "",
	inventoryCount,
}: IProps): ReactElement => {
	const { value, increase, decrease } = useQuantitySelector(max, onChange, initValue);
	const isOutOfStock = inventoryCount === 0;
	const displayValue = isOutOfStock ? 0 : value;
	const display_number = showZero || displayValue > 0;
	const zeroclass = display_number ? "" : "AsZero";

	return (
		<div className={`QuantitySelector ${zeroclass}`} data-testid={`QuantitySelector-${testid}`}>
			<Condition check={display_number}>
				<button
					className="Button Minus"
					onClick={decrease}
					data-testid="QuantityMinus"
					disabled={isOutOfStock}
				/>
				<div className="Count">{displayValue}</div>
			</Condition>
			<button
				className="Button Plus"
				onClick={increase}
				data-testid="QuantityPlus"
				disabled={isOutOfStock}
			/>
		</div>
	);
};

export default memo(QuantitySelector);
